function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2072",
  "data-name": "Group 2072",
  transform: "translate(-1240 -290)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_52",
  "data-name": "Ellipse 52",
  cx: 1.6,
  cy: 1.6,
  r: 1.6,
  transform: "translate(1240 300.398)",
  fill: "#292929"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_53",
  "data-name": "Ellipse 53",
  cx: 1.6,
  cy: 1.6,
  r: 1.6,
  transform: "translate(1240 295.199)",
  fill: "#292929"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_54",
  "data-name": "Ellipse 54",
  cx: 1.6,
  cy: 1.6,
  r: 1.6,
  transform: "translate(1240 290)",
  fill: "#292929"
}));

function SvgThreedots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3.2,
    height: 13.598,
    viewBox: "0 0 3.2 13.598",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreedots);
export default __webpack_public_path__ + "static/media/threedots.5c7b4c6eeadb3148250aa05a4587c669.svg";
export { ForwardRef as ReactComponent };